@if (isOpen) {
<div class="fixed inset-0 flex items-center justify-center z-50">
  <!-- Overlay -->
  <div class="fixed inset-0 bg-black bg-opacity-50" (click)="closeModal()"></div>

  <!-- Content -->
  <div class="relative bg-white shadow-xl z-10
         w-full sm:max-w-2xl
         mx-0 sm:mx-2
         flex flex-col
         my-0 sm:my-2
         h-screen sm:h-auto sm:max-h-[85vh]
         sm:rounded-lg
         overflow-y-auto
">

    <!-- Header -->
    @if (showHeader) {
    <div class="relative flex items-center p-2 sm:p-4">
      @if (showCloseIcon) {
      <button type="button" aria-label="Close" (click)="closeModal()"
        class="absolute right-4 top-1/2 -translate-y-1/2 mr-2 pl-2 text-gray-600 hover:text-gray-800 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      }

      <!-- Título centrado -->
      <h2 class="text-lg font-semibold text-[#0e161b] mx-auto pt-2 font-sans">
        {{ title }}
      </h2>
    </div>
    } @else if (showCloseIcon) {
    <button type="button" aria-label="Close" (click)="closeModal()"
      class="absolute right-4 top-4 mr-2 z-20 text-gray-600 hover:text-gray-800 focus:outline-none"
      [class.mt-4]="isAndroid" [class.mt-2]="!isAndroid">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
    }

    <!-- Body -->
    <div class="p-3 sm:p-6 text-[#0e161b] font-sans">
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    @if (showFooter) {
    <div class="flex flex-row justify-center items-center p-3 sm:p-6 gap-3">
      <app-metro-button text="{{ confirmText | abpLocalization }}" variant="primary" (clicked)="onConfirm()">
      </app-metro-button>
      <ng-content select="[secondary-button]"></ng-content>
    </div>
    }
  </div>
</div>
}